import { gql } from '@apollo/client/index.js'

export const EXPERT_REVIEWS_ADDITIONAL_QUERY = gql`
query ExpertReviewsAdditionalQuery($locale : String! $preview : Boolean!) {
  expertReviewsAdditional :json(id:"6IemG5492tUiqRu7HXa0B4", locale : $locale, preview : $preview) {
    content
  }
}`
